import React from "react";
import { Notification } from "../../services";
import {
  NotifyBellIcon,
  NotifyManIcon,
  NotifyWarnIcon,
} from "../../icons/notify";

const NotificationIcon = (props: { data: Notification }) => {
  const { category, label } = props.data;
  const iconSize = {
    width: 22,
    height: 22,
  };

  const colorClass = (() => {
    switch (label) {
      case 2:
        return "green";
      case 3:
        return "yellow";
      case 4:
        return "red";
      default:
        return "gray";
    }
  })();

  const iconSvg = (() => {
    switch (category) {
      case 1:
        return <NotifyBellIcon {...iconSize} />;
      case 2:
        return <NotifyManIcon {...iconSize} />;
      case 4:
        return <NotifyManIcon {...iconSize} />;
      default:
        return <NotifyWarnIcon {...iconSize} />;
    }
  })();
  return <div className={`notifyIcon ${colorClass}`}>{iconSvg}</div>;
};

export default NotificationIcon;
